import React, { useRef, useState } from "react";
import { withTranslation } from "react-i18next";
import classNames from "classnames";
import "./index.scss";

import { WAITER_TYPES } from "../../../utils/enums";
import {
  getCurrentUserName,
  getRememberMe,
  getAuthorization
} from "../../../utils/auth-util";

import Waiter from "../Waiter/Waiter";
import { useOnClickOutside } from "../../../services/hooks";

const ConfirmDialog = ({
  t,
  isWithPassword,
  isCancelFirst,
  wishThreeButtons,
  handleOnLayout,
  handleOnCancel,
  labelText,
  useWrapperClass,
  useBtnConfirmClass,
  useBtnCancelClass,
  useInputClass,
  handleOnConfirm,
  actionAuthentication,
  cancelOnClickOutside,
  }) => {

  const targetRef = useRef(null);
  useOnClickOutside(targetRef, () => {
    if(cancelOnClickOutside) {
      handleOnCancel();
    }
  });
  
  const [state, setState] = useState({password: ""});

  const handleOnConfirmAction = () => {
    return new Promise((resolve, reject) => {
      if (isWithPassword) {
        actionAuthentication({
          username: getCurrentUserName(),
          password: state.password,
          rememberMe: getRememberMe(),
          skipSave: true,
          skipRetry: true
        })
          .then(data => {
            handleOnConfirm(
                data.token_type + " " + data.access_token,
                state.password
              )
              .then(
                () => {
                  resolve();
                },
                error => {
                  reject(error);
                }
              );
          })
          .catch(() => {
            reject();
          });
      } else {
        handleOnConfirm(getAuthorization())
          .then(() => resolve(), error => reject(error));
      }
    });
  };

  
  return (
    <div ref={targetRef} className={classNames("confirmDialogContainer", { cancelFirst: isCancelFirst }, useWrapperClass || "")}>
      <input type="email" name="email" style={{ width: 0, height: 0 }} />
      <div className={classNames("confirmDialogWrapper", { cancelFirst: isCancelFirst })}>
        {labelText && <span className={classNames("labelText")}>{labelText}</span>}
        {isWithPassword && (
          <input className={classNames("confirmInput", useInputClass ? useInputClass : "")}
            placeholder={t("basic.PASSWORD")}
            type="password"
            value={state.password}
            onChange={e => setState({ password: e.currentTarget.value })}
          />
        )}
        <button className={classNames("btnConfirmCancel", useBtnCancelClass || "")} onClick={handleOnCancel}>
          {t("dashboard.couriersbar.CANCEL_BUTTON")}
        </button>
        {!isCancelFirst && (
          <Waiter useClass={classNames("btnConfirmApply", useBtnConfirmClass || "")}
            type={WAITER_TYPES.button}
            handleOnClick={handleOnConfirmAction}
            stopPropagation={true}
            spanText={t("dashboard.couriersbar.SURE_BUTTON")}
          />
        )}
        {wishThreeButtons && (
          <Waiter useClass={classNames("btnConfirmApply", useBtnConfirmClass || "")}
            type={WAITER_TYPES.button}
            handleOnClick={handleOnLayout}
            stopPropagation={true}
            spanText={t("settings.depots.DEPOT_MENU_COPY_FROM")}
          />
        )}        
      </div>
      {isCancelFirst && (
        <Waiter useClass={classNames("btnConfirmApply", useBtnConfirmClass || "")}
          type={WAITER_TYPES.button}
          handleOnClick={handleOnConfirmAction}
          stopPropagation={true}
          spanText={t("dashboard.couriersbar.SURE_BUTTON")}
        />
      )}
    </div>
  );
}

export default withTranslation()(ConfirmDialog);
